import { z } from "zod";
import { cartItemInputSchema } from "@briolin/shared";
import type { TestDb } from "@briolin/db/src/testing.js";
import { mergeGuestCartIntoServer } from "./core.js";

export const guestCartSchema = z.object({ items: z.array(cartItemInputSchema) });
export type GuestCart = z.infer<typeof guestCartSchema>;

export function parseGuestCart(raw: string | null): GuestCart {
  if (!raw) return { items: [] };
  return guestCartSchema.parse(JSON.parse(raw));
}

// Тонкая обёртка над ядром (объединять по товару — спека §4, открытый вопрос №3 разрешён «объединять»).
export function mergeGuestCart(
  db: TestDb, counterpartyId: string, items: { productId: string; qty: number }[],
): Promise<void> {
  return mergeGuestCartIntoServer(db, counterpartyId, items);
}
